import { useState } from "react";

import { useNavigate } from "react-router";

import { Button, Input } from "ui2";

import { AttendanceLayout } from "safety/components/attendance/AttendanceLayout";

const normalizeCode = (value: string): string => value.trim().toUpperCase().replace(/\s+/g, "");

const MeetingCodeEntryPage = (): React.JSX.Element => {
  const navigate = useNavigate();
  const [code, setCode] = useState("");

  const normalizedCode = normalizeCode(code);

  const goToMeeting = (): void => {
    if (!normalizedCode) return;
    void navigate(`/meeting/${normalizedCode}`);
  };

  return (
    <AttendanceLayout>
      <form
        className="tw:flex tw:w-full tw:flex-1 tw:flex-col tw:gap-4 tw:p-5"
        onSubmit={(event) => {
          event.preventDefault();
          goToMeeting();
        }}
      >
        <div>
          <h1 className="tw:m-0 tw:text-2xl tw:font-denim tw:text-midnight">Safety meeting sign-in</h1>
          <p className="tw:mt-2 tw:mb-0 tw:text-sm tw:text-midnight/60">
            Enter the meeting code your supervisor shared to add yourself to the list.
          </p>
        </div>
        <Input
          label="Meeting code"
          value={code}
          autoFocus
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          onChange={(event) => setCode(event.target.value)}
        />
        <div className="tw:mt-auto tw:pt-2">
          <Button type="submit" className="tw:w-full tw:sm:w-auto" disabled={!normalizedCode}>
            Continue
          </Button>
        </div>
      </form>
    </AttendanceLayout>
  );
};

export default MeetingCodeEntryPage;
